<template>
  <div class="row">
    <jt-select
      class="col-12"
      v-model="oscInstance.selectedValues[objKey]"
      :name="selectName"
      :ref="selectName"
      :label="label"
      :clearable="computedClearable"
      :options="computedOption"
      option-value="id"
      option-label="name"
      :emit-value="false"
      :map-options="false"
      map-value
      @input="onChange"
      @clear="onClear"
    ></jt-select>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtSelect } from 'jtech-webcomps'
import { OrganizationalStructureController } from './OrganizationalStructureController'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    JtSelect
  },
  props: {
    label: String,
    objKey: String,
    onChange: Function,
    onClear: Function,
    isChange: Boolean
  }
})
export default class OrganizationalStructureMenuItem extends Vue {
  oscInstance = OrganizationalStructureController.getInstance()

  get selectName () {
    return `${this.objKey}-select`
  }

  get computedClearable () {
    return this.computedOption.length > 1
  }

  get computedOption () {
    if (!this.parent) {
      return this.oscInstance.organizationalStructureOptions[this.objKey]
    } else {
      return this.oscInstance.organizationalStructureOptions[
        this.objKey
      ].filter(
        (option) =>
          option.parent === this.oscInstance.selectedValues[this.parent]?.id
      )
    }
  }

  get parent () {
    const parentId =
      this.oscInstance.organizationalStructureOptions[this.objKey]?.[0].level - 1
    return parentId ? this.oscInstance.__levelNameMap[parentId]?.key : null
  }
}
</script>
<style>
.organizational-structure-line {
  display: flex;
}
</style>
